import React from 'react';
import PropTypes from 'prop-types';
/* import target from 'assets/img/icons/target.svg';
import discount from 'assets/img/icons/discount.svg';
import networking from 'assets/img/icons/networking.svg'; */
import { Card } from 'react-bootstrap';

const CompanyDescp = ({ data }) => {
 return (
  <Card className="mb-3 bg-transparent border shadow-none d-none d-sm-block">
   <Card.Body>
    <p className="fs--1 mb-0">{data.description}</p>
   </Card.Body>
  </Card>
 );
};

CompanyDescp.propTypes = {
 data: PropTypes.object
};

export default CompanyDescp;
